
import { MutationKey, useQueryClient } from '@tanstack/vue-query'
import { getMessage, onSettledWrapperFn } from './utils'
import { useErrorStore } from 'Store/errors/errorStore'
import { CreateMutationOptions, MutationBaseHookOptions } from 'Common/types/utils/network/querykit/mutationTypes'

/* eslint-disable @typescript-eslint/no-explicit-any */
export function createBaseMutation<
    TData = unknown,
    TVariables = void,
    TError = unknown,
    TContext = unknown
>(
    options: CreateMutationOptions<TData, TError, TVariables, TContext>,
    useMutationHook: (options: any) => any
): any {
    const defaultOptions = options
    const getKey = () => options.mutationKey
    function useGeneratedMutation(options?: MutationBaseHookOptions) {
        const { message, onSettled, ...rest } = { ...defaultOptions, ...options }
        const errorStore = useErrorStore()
        const queryClient = useQueryClient()

        const result = useMutationHook({
            ...rest,
            onSettled: (data, error, variables) => {
                const mutationState = queryClient.getMutationCache().find({ mutationKey: rest.mutationKey as MutationKey })
                onSettledWrapperFn(data, error, () => getMessage(mutationState, variables, message), onSettled, errorStore.pushError)
            }
        })

        return Object.assign(result)
    }

    useGeneratedMutation.getKey = getKey
    useGeneratedMutation.mutationFn = options.mutationFn

    return useGeneratedMutation
}

/* eslint-enable @typescript-eslint/no-explicit-any */
